"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @module
 */
class Dialog {
    /**
     * @function notification: Show alert on screen with custom message
     * @Return void
     */
    notification(message) {
        alert(message);
    }
    /**
     * @function notification: Show alert on screen with custom message
     * @return void
     */
    decision(message) {
        const dialogDecision = confirm(message);
        return dialogDecision;
    }
}
exports.default = Dialog;
//# sourceMappingURL=dialog.js.map